import { Typography, Stack, Divider } from '@mui/material';
import { FC } from 'react';

export const SummaryHeadingColumn: FC<{ topGutter?: boolean }> = ({ topGutter }) => {
  return (
    <Stack sx={{mt: topGutter ? 5.5 : undefined}}>
      <Typography sx={{fontSize: 'small'}}>Antall kunder</Typography>
      <Typography sx={{fontSize: 'small'}}>BFS</Typography>
      <Stack sx={{ml: 1}}>
        <Typography sx={{fontSize: 'small'}}>Komplett</Typography>
        <Stack sx={{ml: 1}}>
          <Typography sx={{fontSize: 'small'}}>Planlegging</Typography>
          <Typography sx={{fontSize: 'small'}}>Byggdetaljer</Typography>
          <Typography sx={{fontSize: 'small'}}>Byggforvaltning</Typography>
          <Typography sx={{fontSize: 'small'}}>Utførelse</Typography>
        </Stack>
      </Stack>
      <Typography sx={{fontSize: 'small'}}>Bvn</Typography>
      <Divider />
      <Typography sx={{fontWeight: 'medium', fontSize: 'small'}}>
        Totalt
      </Typography>
    </Stack>
  );
};
